import { render, staticRenderFns } from "./ContentPageContainer.vue?vue&type=template&id=fff86af2&scoped=true"
import script from "./ContentPageContainer.vue?vue&type=script&lang=ts"
export * from "./ContentPageContainer.vue?vue&type=script&lang=ts"
import style0 from "./ContentPageContainer.vue?vue&type=style&index=0&id=fff86af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff86af2",
  null
  
)

export default component.exports